import { createAction, props } from "@ngrx/store";
import AutoArchiveRuleRow from "src/app/model/auto-archive/AutoArchiveRuleRow";

export enum AutoArchiveActionTypes {
    LoadRules = "[Auto Archive] Load Rules",
    LoadRulesSuccess = "[Auto Archive] Load Rules Success",
    LoadRulesFailure = "[Auto Archive] Load Rules Failure",

    CreateRule = "[Auto Archive] Create Rule",
    CreateRuleSuccess = "[Auto Archive] Create Rule Success",
    CreateRuleFailure = "[Auto Archive] Create Rule Failure",

    UpdateRule = "[Auto Archive] Update Rule",
    UpdateRuleSuccess = "[Auto Archive] Update Rule Success",
    UpdateRuleFailure = "[Auto Archive] Update Rule Failure",

    DeleteRule = "[Auto Archive] Delete Rule",
    DeleteRuleSuccess = "[Auto Archive] Delete Rule Success",
    DeleteRuleFailure = "[Auto Archive] Delete Rule Failure",
}

export const loadRules = createAction(AutoArchiveActionTypes.LoadRules);

export const loadRulesSuccess = createAction(
    AutoArchiveActionTypes.LoadRulesSuccess,
    props<{ rules: AutoArchiveRuleRow[] }>()
);

export const loadRulesFailure = createAction(
    AutoArchiveActionTypes.LoadRulesFailure,
    props<{ error: string }>()
);

export const createRule = createAction(
    AutoArchiveActionTypes.CreateRule,
    props<{ rule: any }>()
);

export const createRuleSuccess = createAction(
    AutoArchiveActionTypes.CreateRuleSuccess,
    props<{ rule: AutoArchiveRuleRow }>()
);

export const createRuleFailure = createAction(
    AutoArchiveActionTypes.CreateRuleFailure,
    props<{ error: string }>()
);

export const updateRule = createAction(
    AutoArchiveActionTypes.UpdateRule,
    props<{ id: number; rule: any }>()
);

export const updateRuleSuccess = createAction(
    AutoArchiveActionTypes.UpdateRuleSuccess,
    props<{ rule: AutoArchiveRuleRow }>()
);

export const updateRuleFailure = createAction(
    AutoArchiveActionTypes.UpdateRuleFailure,
    props<{ error: string }>()
);

export const deleteRule = createAction(
    AutoArchiveActionTypes.DeleteRule,
    props<{ id: number }>()
);

export const deleteRuleSuccess = createAction(
    AutoArchiveActionTypes.DeleteRuleSuccess,
    props<{ id: number }>()
);

export const deleteRuleFailure = createAction(
    AutoArchiveActionTypes.DeleteRuleFailure,
    props<{ error: string }>()
);
